var map = {
	"./assets/frameworks/we": [
		"0b52",
		9
	],
	"./assets/frameworks/we.js": [
		"0b52",
		9
	],
	"./assets/frameworks/we/_custom.scss": [
		"46c5",
		7,
		"applications-saffronfiles-assets-frameworks-we-_custom-scss"
	],
	"./assets/frameworks/we/_mixins.scss": [
		"9fe4",
		7,
		"applications-saffronfiles-assets-frameworks-we-_mixins-scss"
	],
	"./assets/frameworks/we/_variables.scss": [
		"940a",
		7,
		"applications-saffronfiles-assets-frameworks-we-_variables-scss"
	],
	"./assets/frameworks/we/saffronAdapter": [
		"dc9c",
		9
	],
	"./assets/frameworks/we/saffronAdapter.js": [
		"dc9c",
		9
	],
	"./assets/frameworks/we/we": [
		"bbfe",
		9
	],
	"./assets/frameworks/we/we.js": [
		"bbfe",
		9
	],
	"./assets/frameworks/we/we.scss": [
		"a661",
		7
	],
	"./assets/scss/_test.scss": [
		"44fe",
		7,
		"applications-saffronfiles-assets-scss-_test-scss"
	],
	"./assets/static/core/images/boxy/default-background.webp": [
		"3279",
		7
	],
	"./assets/static/core/images/index.html": [
		"65a1",
		7
	],
	"./assets/static/core/images/logos/main.png": [
		"0f5d",
		7
	],
	"./assets/static/core/images/logos/main.svg": [
		"2aa4",
		7
	],
	"./assets/static/core/images/user/login/boxy_background_2.jpg": [
		"34b4",
		7
	],
	"./assets/static/core/images/user/login/boxy_background_3.jpg": [
		"09e6",
		7
	],
	"./assets/static/core/index.html": [
		"77a1",
		7
	],
	"./assets/static/images/backgrounds/boxy-default.webp": [
		"66ce",
		7
	],
	"./assets/static/images/dashboard/backgrounds/dashboard-main-bg-2.jpg": [
		"6146",
		7
	],
	"./assets/static/images/dashboard/backgrounds/dashboard-main-bg-3.jpg": [
		"b1b4",
		7
	],
	"./assets/static/images/dashboard/backgrounds/dashboard-main-bg-4.jpg": [
		"6f5f",
		7
	],
	"./assets/static/images/dashboard/backgrounds/dashboard-main-bg-5.jpg": [
		"b13b",
		7
	],
	"./assets/static/images/dashboard/backgrounds/dashboard-main-bg-small.png": [
		"cf15",
		7
	],
	"./assets/static/images/dashboard/backgrounds/dashboard-main-bg-small.webp": [
		"0539",
		7
	],
	"./assets/static/images/dashboard/backgrounds/dashboard-main-bg.jpg": [
		"c676",
		7
	],
	"./assets/static/images/dashboard/backgrounds/dashboard-main-bg.png": [
		"6a06",
		7
	],
	"./components/App": [
		"6abe",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"applications-saffronfiles-components-App"
	],
	"./components/App.vue": [
		"6abe",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"applications-saffronfiles-components-App"
	],
	"./components/Playground": [
		"a366",
		9,
		"applications-saffronfiles-components-Playground"
	],
	"./components/Playground.vue": [
		"a366",
		9,
		"applications-saffronfiles-components-Playground"
	],
	"./components/readme.md": [
		"24a6",
		7,
		"applications-saffronfiles-components-readme-md"
	],
	"./config/modules/locale": [
		"3bfd",
		9
	],
	"./config/modules/locale.js": [
		"3bfd",
		9
	],
	"./config/modules/readme.md": [
		"e2bd",
		7,
		"applications-saffronfiles-config-modules-readme-md"
	],
	"./config/modules/router": [
		"a355",
		9
	],
	"./config/modules/router.js": [
		"a355",
		9
	],
	"./config/modules/style": [
		"78b0",
		9
	],
	"./config/modules/style.js": [
		"78b0",
		9
	],
	"./config/modules/user": [
		"20bb",
		9
	],
	"./config/modules/user.js": [
		"20bb",
		9
	],
	"./config/root": [
		"4f19",
		9
	],
	"./config/root.js": [
		"4f19",
		9
	],
	"./extensions/validation/validatorFactories/availableOnRemote": [
		"e9c9",
		9
	],
	"./extensions/validation/validatorFactories/availableOnRemote.js": [
		"e9c9",
		9
	],
	"./extensions/validation/validators/anyI18nPhoneNumber": [
		"3bed",
		9
	],
	"./extensions/validation/validators/anyI18nPhoneNumber.js": [
		"3bed",
		9
	],
	"./extensions/validation/validators/cleanIsraelyMobilePhoneNumber": [
		"efeb",
		9
	],
	"./extensions/validation/validators/cleanIsraelyMobilePhoneNumber.js": [
		"efeb",
		9
	],
	"./extensions/validation/validators/goodPassword": [
		"bdc3",
		9
	],
	"./extensions/validation/validators/goodPassword.js": [
		"bdc3",
		9
	],
	"./extensions/validation/validators/i18nPhoneNumber": [
		"41f9",
		9
	],
	"./extensions/validation/validators/i18nPhoneNumber.js": [
		"41f9",
		9
	],
	"./extensions/validation/validators/i18nPhoneNumberObject": [
		"4bbf",
		9
	],
	"./extensions/validation/validators/i18nPhoneNumberObject.js": [
		"4bbf",
		9
	],
	"./extensions/validation/validators/israelyPersonalId": [
		"b5fb",
		9
	],
	"./extensions/validation/validators/israelyPersonalId.js": [
		"b5fb",
		9
	],
	"./extensions/validation/validators/readme.md": [
		"a72b",
		7,
		"applications-saffronfiles-extensions-validation-validators-readme-md"
	],
	"./extensions/validation/validators/urlSafeString": [
		"efa2",
		9
	],
	"./extensions/validation/validators/urlSafeString.js": [
		"efa2",
		9
	],
	"./layouts/Default": [
		"0ae7",
		9,
		"applications-saffronfiles-layouts-Default"
	],
	"./layouts/Default.vue": [
		"0ae7",
		9,
		"applications-saffronfiles-layouts-Default"
	],
	"./locale/en-US/locale": [
		"8374",
		9
	],
	"./locale/en-US/locale.js": [
		"8374",
		9
	],
	"./locale/en-US/messages": [
		"caf3",
		9
	],
	"./locale/en-US/messages.js": [
		"caf3",
		9
	],
	"./locale/he-IL/locale": [
		"08df",
		9
	],
	"./locale/he-IL/locale.js": [
		"08df",
		9
	],
	"./locale/he-IL/messages": [
		"2732",
		9
	],
	"./locale/he-IL/messages.js": [
		"2732",
		9
	],
	"./pages": [
		"b1af",
		9,
		"applications-saffronfiles-pages"
	],
	"./pages/": [
		"b1af",
		9,
		"applications-saffronfiles-pages"
	],
	"./pages/index": [
		"b1af",
		9,
		"applications-saffronfiles-pages"
	],
	"./pages/index.vue": [
		"b1af",
		9,
		"applications-saffronfiles-pages"
	],
	"./pages/playground": [
		"6d82",
		9,
		"applications-saffronfiles-pages-playground"
	],
	"./pages/playground.vue": [
		"6d82",
		9,
		"applications-saffronfiles-pages-playground"
	],
	"./pwaConfig": [
		"ebc3",
		7
	],
	"./pwaConfig.js": [
		"ebc3",
		7
	],
	"./router/middleware/redirectsLike404": [
		"50b3",
		9
	],
	"./router/middleware/redirectsLike404.js": [
		"50b3",
		9
	],
	"./router/middleware/requireGuest": [
		"c5b6",
		9
	],
	"./router/middleware/requireGuest.js": [
		"c5b6",
		9
	],
	"./router/middleware/requireSuperAdmin": [
		"19ff",
		9
	],
	"./router/middleware/requireSuperAdmin.js": [
		"19ff",
		9
	],
	"./router/middleware/requireUser": [
		"a669",
		9
	],
	"./router/middleware/requireUser.js": [
		"a669",
		9
	],
	"./router/routes/core": [
		"d13b",
		9
	],
	"./router/routes/core.js": [
		"d13b",
		9
	],
	"./router/routes/errors": [
		"2258",
		9
	],
	"./router/routes/errors.js": [
		"2258",
		9
	],
	"./router/routes/readme.md": [
		"5ff3",
		7,
		"applications-saffronfiles-router-routes-readme-md"
	],
	"./saffronfiles": [
		"6f07",
		9
	],
	"./saffronfiles.js": [
		"6f07",
		9
	],
	"./store/modules/readme.md": [
		"e1c3",
		7,
		"applications-saffronfiles-store-modules-readme-md"
	],
	"./views/PageNotFound": [
		"55f3",
		9,
		"applications-saffronfiles-views-PageNotFound"
	],
	"./views/PageNotFound.vue": [
		"55f3",
		9,
		"applications-saffronfiles-views-PageNotFound"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "76b7";
module.exports = webpackAsyncContext;